import classNames from 'classnames'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import type { ReactNode, ReactElement, PropsWithChildren } from 'react'
import type { IAnalyticTooltip } from '~/types/analytic'

import AnalyticBlockMenu from '../AnalyticBlocksMenu'
import AnalyticTooltip from '../AnalyticsTooltip'

import BlockTitle from '~/components/Blocks/Title'
import GridItemLayout from '~/components/GridItemLayout'
import SkeletonLoader from '~/components/SkeletonLoader'

import './styles.scss'

export const AnalyticBlockFilter = ({ children }: PropsWithChildren): ReactElement => {
  return <div className="filter">{children}</div>
}

interface Props {
  className?: string
  isDraggable?: boolean
  isLoading?: boolean
  linkedTo?: string
  title: ReactNode
  tooltipValue?: IAnalyticTooltip
}

const AnalyticGenericBlock = ({
  children,
  className,
  isDraggable = true,
  isLoading,
  linkedTo,
  title,
  tooltipValue,
}: PropsWithChildren<Props>): ReactElement => {
  /** Local state */

  const navigate = useNavigate()

  const [isBlockHovered, setIsBlockHovered] = useState(false)

  const analyticsGenericBlockContainer = classNames('analytics-generic-block-container', className, {
    clickable: !!linkedTo,
    draggable: isDraggable,
    'wrapper-hovered': isBlockHovered,
  })

  /** Handlers */

  const handleHover = (value: boolean) => () => setIsBlockHovered(value)

  const handleNavigate = () => linkedTo && navigate(linkedTo)

  /** Render */

  return (
    <GridItemLayout
      className={analyticsGenericBlockContainer}
      isLoading={isLoading}
      onClick={handleNavigate}
      onMouseEnter={handleHover(true)}
      onMouseLeave={handleHover(false)}
    >
      {isLoading ? (
        <SkeletonLoader />
      ) : (
        <>
          <AnalyticBlockMenu>{tooltipValue ? <AnalyticTooltip value={tooltipValue} /> : null}</AnalyticBlockMenu>
          <BlockTitle className="analytics-generic-block-container__title">{title}</BlockTitle>
          {children}
        </>
      )}
    </GridItemLayout>
  )
}

export default AnalyticGenericBlock
